import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';

import { selectedLicenseTypeNatureSelector } from '../modules/License/store/selectors';

import { routesByNature } from '../constants/routes';

import useLicenseTypeNature from './useLicenseTypeNature';

function useRedirect() {
  const licenseTypeNature = useSelector(selectedLicenseTypeNatureSelector);
  const natureFromRoute = useLicenseTypeNature();

  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  if (
    licenseTypeNature &&
    // @ts-expect-error licenses with EXEMPTION type are causing infinite loop,
    // we're not supposed to have EXEMPTION type for now, adding it to enum will bring a lot of changes
    // for now will be handled with workaround
    licenseTypeNature !== 'EXEMPTION' &&
    natureFromRoute &&
    licenseTypeNature !== natureFromRoute
  ) {
    const newRoute = pathname.replace(routesByNature[natureFromRoute], routesByNature[licenseTypeNature]);
    navigate(`${newRoute}${search}`);
  }
}

export default useRedirect;
